import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavBar } from '../components/dashboard/navbar/NavBar';
import { SideBar } from '../components/dashboard/sidebar/SideBar';

export const PrivateRoute = ({ isAuthenticated, bars = true }) => {
	return isAuthenticated ? (
		<div style={dashboardStyle}>
			{ bars && <SideBar /> }
			<div style={contentStyle}>
				{ bars && <NavBar /> }
				<Outlet />
			</div>
		</div>
	) : (
		<Navigate to='/auth/inicio-de-sesion' />
	);
};

const contentStyle = {
	width: '100%',
};

const dashboardStyle = {
	display: 'flex',
	flexDirection: 'row',
};
